import React from "react";
import Jane from "../Assets/jane.png";
import Thomas from "../Assets/thomas.png";
import { AiFillStar } from "react-icons/ai";

const Testimonial = () => {
  return (
    <div className="testimonial-section-wrapper">
      <div className="work-section-top">
        <p className="primary-subheading">Testimonial</p>
        <h1 className="primary-heading">What They Are Saying</h1>
      </div>
      <div className="testimonial-sections-container">
      <div className="testimonial-section-bottom">
        <img src={Thomas} alt="" />
        <p>
          "I had been struggling to lose weight for years, trying every fad diet out there with no success. But then I came across this amazing book of recipes that changed everything. The recipes were delicious and easy to make, and I finally started seeing the results I wanted. I would recommend this book to anyone looking for a sustainable and healthy way to lose weight"
        </p>
        <div className="testimonials-stars-container">
          <AiFillStar />
          <AiFillStar />
          <AiFillStar />
          <AiFillStar />
          <AiFillStar />
        </div>
        <h4>Thomas Baker</h4>
      </div>
      <div className="testimonial-section-bottom">
        <img src={Jane} alt="" />
        <p>
          "They not only provided me with delicious and healthy recipes to help me achieve my weight loss goals, but they also took the time to listen to my concerns and tailor their recommendations to fit my specific needs individually. Thanks to their expertise, I've been able to make sustainable changes to my diet and feel better than ever before"
        </p>
        <div className="testimonials-stars-container">
          <AiFillStar />
          <AiFillStar />
          <AiFillStar />
          <AiFillStar />
          <AiFillStar />
        </div>
        <h4>Jane Smith</h4>
      </div>
      </div>
    </div>
  );
};

export default Testimonial;
